import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';

import * as Styled from '../LoyaltyPageSeparated.styles';

interface JanymdaTopupModalProps {
  open: boolean;
  onClose: () => void;
}

/* --- иконки --- */
const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 8h.01M11 11h1.5v6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2L12 16.9l-5.6 3.1 1.4-6.2-4.8-4.3 6.4-.6L12 3z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

/* --- шаги пополнения --- */
interface TopupStep {
  number: number;
  titleKey: string;
  textKey: string;
  image: string;
}

const TOPUP_STEPS: TopupStep[] = [
  {
    number: 1,
    titleKey: 'STEP1_TITLE',
    textKey: 'STEP1_TEXT',
    image: '/images/janymda-topup-step-1.png',
  },
  {
    number: 2,
    titleKey: 'STEP2_TITLE',
    textKey: 'STEP2_TEXT',
    image: '/images/janymda-topup-step-2.png',
  },
  {
    number: 3,
    titleKey: 'STEP3_TITLE',
    textKey: 'STEP3_TEXT',
    image: '/images/janymda-topup-step-3.png',
  },
];

const topupKey = (suffix: string) => `LoyaltySeparated.TopupModal.${suffix}`;

const JanymdaTopupModal: React.FC<JanymdaTopupModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Styled.ModalOverlay onClick={onClose}>
        <Styled.ModalCard onClick={(e) => e.stopPropagation()}>
          <Styled.CloseButton type="button" onClick={onClose}>
            <CloseIcon />
          </Styled.CloseButton>

          <Styled.ModalHeader>
            <Styled.ModalTitle>{t(topupKey('TITLE'))}</Styled.ModalTitle>
            <Styled.ModalSubtitle>
              {t(topupKey('SUBTITLE'))}
            </Styled.ModalSubtitle>
          </Styled.ModalHeader>

          <Styled.InfoBox>
            <span className="info-icon">
              <InfoIcon />
            </span>
            <div>
              <span className="info-title">{t(topupKey('INFO_TITLE'))}</span>
              <ul>
                <li>
                  <Trans i18nKey={topupKey('INFO_LINE1')} />
                </li>
                <li>
                  <Trans i18nKey={topupKey('INFO_LINE2')} />
                </li>
                <li>
                  <Trans i18nKey={topupKey('INFO_LINE3')} />
                </li>
              </ul>
            </div>
          </Styled.InfoBox>

          <Styled.SectionTitle>
            {t(topupKey('STEPS_TITLE'))}
          </Styled.SectionTitle>

          <Styled.StepsGrid>
            {TOPUP_STEPS.map((step) => (
              <Styled.StepCard key={step.number}>
                <Styled.StepHeader>
                  <span className="step-number">{step.number}</span>
                  <span className="step-title">
                    {t(topupKey(step.titleKey))}
                  </span>
                </Styled.StepHeader>
                <Styled.StepText>{t(topupKey(step.textKey))}</Styled.StepText>
                <Styled.StepImageFrame>
                  <img src={step.image} alt={t(topupKey(step.titleKey))} />
                </Styled.StepImageFrame>
              </Styled.StepCard>
            ))}
          </Styled.StepsGrid>

          <Styled.AdditionalBox>
            <span className="additional-icon">
              <StarIcon />
            </span>
            <div>
              <span className="additional-title">
                {t(topupKey('ADDITIONAL_TITLE'))}
              </span>
              <span className="additional-text">
                {t(topupKey('ADDITIONAL_TEXT'))}
              </span>
            </div>
          </Styled.AdditionalBox>
        </Styled.ModalCard>
      </Styled.ModalOverlay>
    </Modal>
  );
};

export default JanymdaTopupModal;
